module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p14-15.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', {
    staticClass: "bold"
  })]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("TEASE")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('p', {
    staticClass: "ch_intro_para"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("The secret to a successful tease lies within your ability to hold back and enjoy the journey")]), _vm._v(". Whoever came up with the phrase “the best things come to those who wait” was obviously a devoted fan of teasing. The art of the tease is all about sparking, fanning, and prolonging desire. It can be as simple as a flash of skin, a hint of leg, or a brush of the hand. Whether you’re in your living room or out on a date, take steps to create an erotic and fun mood and to get the sexual temperature rising. Where to begin? That’s easy—start with your mouth. Words are powerful tools of temptation, so begin by talking about what you’d like to do to each other. Voicing your desires is a huge turn-on and a great way to learn about your partner, and it opens up communication for all the sexy fun that’s to come. Then it’s time to start touching each other, but do it oh-so-slowly. Stroke and caress each other’s bodies, enjoying the anticipation as it builds and builds—the best tease lasts until it makes you feel as if you can’t control your desire for a single second longer.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("1 START THE SEDUCTION")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "display-headnote"
  }, [_vm._v("Teasing is the classic way to start up something steamy—and the longer you savor the suspense, the better. The sexiest tease sessions draw on all the senses.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It all begins with just a touch or a glance. Eye contact is one of the best ways to communicate desire. Watch your lover watching you. Then smile, lick your lips, and raise those brows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once you’ve locked eyes, your touch is another way to express amorous intent. A full-on sensual caress isn’t the only way to flirt with your hands; try a light but long-lasting touch as a subtle and nonverbal way to speak volumes. Place your hand on top of your partner’s hand, or let your fingers linger on a shoulder. Your feet are another great way to deepen a sparking connection, especially in public. Play a game of “footsie” when your feet aren’t in full view, and act like nothing’s going on. Gently rub up against your partner’s feet (this works well under a table), then slide your toes from ankle to knee. You can take advantage of the sexy feel of your shoe’s leather, or flick it off and use your bare skin or stocking feet. Go as high as you dare, and secretly turn each other on without the rest of the world being turned on to your seduction.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("2 FLIRTING IS FUN")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "quad-headnote"
  }, [_vm._v("TEASE BEFORE GETTING DOWN TO BUSINESS—GET YOUR FLIRT GOING STRONG.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE MANE EVENT")]), _vm._v(" Use your head—or more precisely, your hair—to arouse his interest. Toss those tresses, then run your fingers through them or girlishly twist a curl. Lean in close so he can inhale the clean scent of your shampoo.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PAY ATTENTION")]), _vm._v(" You don’t have to do or plan anything explicit to flirt with a woman—just use your eyes and words to show her that she’s got you riveted. Ask her questions, cleverly riff on her answers, and you’ll be well on your way.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p19.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FOOD FOR THOUGHT")]), _vm._v(" Watching you eat gets a man thinking about what else you can do with those lips. Play it up with tasty treats that look suggestive, like ice pops, and he’ll start thinking about eating you up, too.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p19a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SEXTING")]), _vm._v(" Sexy texting is a modern way to amp up the passion. Text a naughty fantasy or a hot memory, or talk about what you want to do when you see each other next. Throw in a sexy detail or two, but keep it short and sweet.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('p', {
    staticClass: "intro_text-poem"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1c"
  }, [_vm._v("Jamye")])])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "wordswisdom_paragraph"
  }, [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("“")])]), _vm._v("We’re not fooling")]), _vm._v(" around when we say that making out is really worth your while. Before you seal the deal, do more kissing and clothed caressing, and watch sparks fly."), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("”")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro_text-poem"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1c"
  }, [_vm._v("Emily")])])]), _vm._v(" "), _c('p', {
    staticClass: "wordswisdom_paragraph"
  }, [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("“")])]), _vm._v("I like the idea")]), _vm._v(" of temporarily delaying intercourse so you can focus on kissing and foreplay. Think of foreplay as stretching before a workout—you’re simply warming up your body for more action."), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("”")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22-23.jpg"
    }
  })])]), _c('p', {
    staticClass: "sidebar_caption"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("For a thrill that’s just between the two of you, get on top of him and sway your hips against his. You’ll feel him getting turned on, and nobody else will know")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("3 MAKE-OUT MADNESS")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "a_main_paragraph0"
  }, [_vm._v("Sex starts long before the clothes fly off. In fact, some of the most intense moments may come when you’re fully clothed. Remember wrestling with your high-school boyfriend on the living room couch while your mom made dinner? Channel that energy, and do all that you possibly can with your clothes on. When they finally start coming off, you’ll be amazed how turned on you are.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "c_inset_label_caption"
  }, [_vm._v("One of the best things about making out with your clothes on is that you can do it anywhere. You can take it to the limit on a park bench, at the movies, or at the beach and then finish things up when you get home.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p24.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("4 PUT ON A PEEP SHOW")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "display-headnote"
  }, [_vm._v("Going all the way in public can get tricky, but a brief glimpse of skin gives him a tantalizing visual treat—plus a preview of the pleasures that lie ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph0"
  }, [_vm._v("Furtive flashes can be a great way to amp up the sexual tension. Be sure to dress for sexy success—any coat that’s long enough to be worn as a dress or robe will work: just wear nothing underneath and go for a stroll together. When the spot feels secluded enough, open your coat and give him an eyeful.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph"
  }, [_vm._v("For another type of sneak peek, try “accidentally” dropping your fork when you’re at a restaurant. When your date goes to pick it up, open your knees so he can see that you’re not wearing undies. Don’t underestimate how even a quick glimpse can spark his imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph"
  }, [_vm._v("With or without panties, stockings and garter belts add a little ooh-la-la. Or slip on thigh-high fishnets and make sure your honey gets a good look at the sweet spot where fabric meets flesh.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph"
  }, [_vm._v("If his attention tends to focus a bit higher on your anatomy, put on a saucy bra or go braless the next time the two of you go out. Wear a loose, scoop-neck shirt so you can bend forward and give him a taste of what’s next on the menu.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("5 PERFORM A SEXY STRIPTEASE")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{1}")]), _vm._v(" Have your partner pick out the clothes he’d like to see you remove. Remember, he thinks you’re sexy even if you aren’t a supermodel.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{2}")]), _vm._v(" Tease him by running your hands over your clothed body.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{3}")]), _vm._v(" A skirt can trip up even seasoned strippers. Pin it to the floor with one foot, then step out with the other.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{4}")]), _vm._v(" Flatter any figure by saucily cocking your hip to the side.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{5}")]), _vm._v(" Play with your hair for sensual appeal. Pull it away from your face, then let it fall in loose, sexy tendrils.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{6}")]), _vm._v(" Eye contact enhances mutual attraction. So be sure to watch your partner watching you.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p28.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("6 ROCK THOSE MANLY MOVES")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "display-headnote"
  }, [_vm._v("You don’t need the body of an athlete or the moves of a Chippendales dancer to put on a hot show for your partner. Just let yourself get caught up in the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph0"
  }, [_vm._v("Sexy stripper moves are not just for women—it’s time for the guys to strike a pose and dance for their lovers at home. Tear-away pants and thong bikinis are not required, just wear the clothes that she likes to see you in and that make you feel confident—whether that happens to be a power suit or boxer briefs.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph"
  }, [_vm._v("Seat your audience of one, put on a sexy song, and stand a few feet in front of her. Tighten up those abs and arch your back slightly so you look your best. Move your hips in time with the music. Get closer and maintain eye contact as you place one foot in between her legs and circle your hips over her thigh. Bend your knees and grind against her leg. Then turn around and shake your butt. Remove your clothing slowly, sliding your hands all over your body.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph"
  }, [_vm._v("To heighten the sexual tension, follow the rules of a strip club: she can look, but she can’t touch. Get as close as you can without actually making contact with her (or brush across her skin briefly), and she’ll likely insist on a steamy encore.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30-31.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "intro_text-poem"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1e"
  }, [_vm._v("Emily")])])]), _vm._v(" "), _c('p', {
    staticClass: "wordswisdom_paragraph"
  }, [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("“")])]), _vm._v("Remember, kisses")]), _vm._v(" aren’t just for the lips. Try planting kisses on the often-neglected neck, ears, nose, eyelids, fingers—you get the picture. Sometimes a kiss in an unexpected place is just what these other erogenous zones ordered."), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("”")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro_text-poem"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1e"
  }, [_vm._v("Jamye")])])]), _vm._v(" "), _c('p', {
    staticClass: "wordswisdom_paragraph"
  }, [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("“")])]), _vm._v("When it comes")]), _vm._v(" to kissing, it definitely takes some time to find the right rhythm. Play follow-the-leader, and have one person lead the kiss, while the other person follows their moves. Then switch!"), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("”")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("7 MAKE THE MOST OF YOUR MOUTH")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "quad-headnote"
  }, [_vm._v("SEX IS A BANQUET—FEEL FREE TO LICK, NIBBLE, AND BITE ALL YOU WANT.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 GAZE")]), _vm._v(" We can’t emphasize this point enough—eye contact adds heat to intimate interactions. Look long, and gaze deeply into each other’s pupils. Guiding your partner’s face in toward yours is a sexy, take-charge move.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 KISS")]), _vm._v(" Kissing can be done in many ways, so try out a range of techniques. Go soft and tentative with your lips barely brushing one another. Next, try long, deep kisses with lots of tongue. Nibble gently on the lower lip.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 LICK")]), _vm._v(" To raise the temperature, use that tongue. For playful goodness, visit the neck and ears as well as some often-ignored erogenous zones—like the bends in the arms, behind the knees and between fingers and toes.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 BITE")]), _vm._v(" Don’t be afraid to use your teeth to give your partner added pleasure (and a sexy hint of pain). Light bites are a good way to start. Begin gently with the ears and the neck. If your partner enjoys it, build up to harder pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("8 LINGER IN YOUR LINGERIE")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "display-headnote"
  }, [_vm._v("What’s sexier than a half-naked man or woman? Enjoy the view—and the sizzling sense of anticipation—as you start to get hot, heavy, and excited to go all the way.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph0"
  }, [_vm._v("The temperature is rising, and by now you’re getting hot and heavy. The natural impulse is to just rip each other’s clothes off and go wild. Instead, keep the tension building. Once you take it all off, there’s only one thing left to do. Making the most of the delicious moment just before sex will bring your arousal levels to a fever pitch. Humans are visual creatures, so take a moment to appreciate how your partner looks when nearly naked. Run your fingers over erogenous zones, letting the texture of the cloth amplify your touch. Slide your fingers under waistbands and straps—but not too far.")]), _vm._v(" "), _c('p', {
    staticClass: "a_main_paragraph"
  }, [_vm._v("Undergarments create just the right amount of obstacle to intercourse (unless of course you just slide them to the side and have sex without getting fully undressed, which can be a really hot move). Before you remove those last little pieces of fabric, kiss and touch everywhere else. Build up the excitement with eye contact and erotic talk until you can’t stand it any longer and absolutely must move on to the main event.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("9 SKIN-ON-SKIN SENSATIONS")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{1}")]), _vm._v(" The ears are sensitive to touch and immensely sensual. Trace the lobes, then gently massage the tips and the area behind the ears.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{2}")]), _vm._v(" Reach for the hands and apply pressure in sweeping arcs over the palms, then work between the fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{3}")]), _vm._v(" Slather on massage lotion and work the feet from heel to toe. Tip: the back of the foot above the heel is a supersweet spot.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{4}")]), _vm._v(" When massaged, the dimples in the lower back can release erotic energy. Try a circular motion.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36e.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "b_side_caption"
  }, [_c('span', {
    staticClass: "col1d"
  }, [_vm._v("{5}")]), _vm._v(" Brush up the inner thigh from the knee to just under the hip with long, sweeping strokes.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "b_side_caption"
  }, [_vm._v("Caress the area around and between the breasts, then cup and gently squeeze them. Then circle her nipples and try pinching them lightly.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("10 DRESSING DOWN")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "quad-headnote"
  }, [_vm._v("A LITTLE AUDIENCE PARTICIPATION CAN MAKE A STRIPTEASE EVEN HOTTER.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p38a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SLOW HANDS")]), _vm._v(" Take your time removing her bra. Before you start, look into her eyes and tell her how hot she is. Slowly slide the straps down while caressing her shoulders. Can’t figure out the clasp? She’s likely going to be eager to help.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p38b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ANIMAL INSTINCTS")]), _vm._v(" When undressing your partner, try channeling your wild side. Sure, hands are fine for disrobing, but why not (carefully!) use your teeth? Tearing at his jeans like a tiger may turn your bedroom into a wild kingdom.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("(UN)BUTTONED DOWN")]), _vm._v(" If his shirt is one that slips over his head, ask him to raise his arms and playfully tug it off. If it has buttons, undo them one at a time and kiss or lick each new inch of torso as it’s exposed. Tease his nipples just a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PANTY RAID")]), _vm._v(" Use your fingertips to trace the outline of her privates through the thin fabric of her underwear. Place a finger or two under the waistband, but don’t go too far down. Once she starts to squirm, slowly slide those panties off.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40-41.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("11 A SOLO SHOW")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "a_main_paragraph0"
  }, [_vm._v("Who says learning can’t be fun? Mutual masturbation is a great way for lovers to show each other the moves that drive them wild. As you’ve probably already figured out by now, touching yourself feels good, but it can also be a teaching tool. And watching your partner in the throes of pleasure will further stoke desire, encouraging you to turn solo adventures into even more gratifying partner exploration.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "c_inset_label_caption"
  }, [_vm._v("Watching while a partner strokes his or her genitals is a sexy way to learn exactly how they like to be touched.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "c_inset_label_caption"
  }, [_vm._v("Place your hand on his (or vice versa) so you can share a caress. It builds intimacy and instructs without words.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p42-43.jpg"
    }
  })])]), _c('p', {
    staticClass: "intro_text-poem"
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1f"
  }, [_vm._v("Emily")])])])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "wordswisdom_paragraph"
  }, [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("“")])]), _vm._v("When you focus")]), _vm._v(" on the senses, even one at a time, you’re on your way to great sex. Try targeting the area near a hot zone. For example, trace your fingers around nipples or along the inner thighs. Stimulating nerve endings that radiate outward from the hot spots will lead to more thrilling sensations."), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col3"
  }, [_vm._v("”")])])])]), _c('p', {
    staticClass: "intro_text-poem"
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1f"
  }, [_vm._v("Jamye")])])])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "wordswisdom_paragraph"
  }, [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col2"
  }, [_vm._v("“")])]), _vm._v("Try getting kinky")]), _vm._v(" in your kitchen. Place a tablecloth down on a counter or tabletop, then open the freezer and tease your lover with ice cubes. Grab a stick of butter and get your baby all slippery. Take a wooden spoon and use it for light love taps. Get creative when it comes to stirring up the senses."), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col3"
  }, [_vm._v("”")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44-45.jpg"
    }
  })])]), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("12 TEASING TOUCH")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "a_main_paragraph0"
  }, [_vm._v("Massage is marvelous, but it isn’t the only way to make a partner go weak in the knees. Fingers, palms, and knuckles make things tingle, but for added adventure, try using accessories like jewelry, silk scarves, feathers, and gloves. Sweep them around the base of his penis or trail them all over her body. Explore with both light and hard touches, adjusting your technique based on your partner’s responses.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "c_inset_label_caption"
  }, [_vm._v("A satin or velvet over-the-elbow glove looks incredibly elegant, and feels amazing on bare skin. Use your gloved hand to stroke him lightly from head to toe.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "c_inset_label_caption"
  }, [_vm._v("Tease him by trailing smooth beads down his body. Then wrap them loosely around the penis shaft and roll them up and down.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "head-num-header",
    attrs: {
      "id": "a13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("13 SURPRISING SENSATIONS")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "quad-headnote"
  }, [_vm._v("BE IT HOT OR COLD, FINGERS OR FEATHERS, THE UNEXPECTED CAN BE OH-SO-SEXY.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p46a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ICE, ICE BABY")]), _vm._v(" When you want to give someone a delicious chill, take a cube of ice and slide it over the neck, nipples, and belly. Or keep a piece in your mouth as you let your lips explore your partner’s contours and erogenous areas.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p46b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BLINDERS ON")]), _vm._v(" When you remove one sense, you heighten the others. Use a scarf or a necktie to cover your partner’s eyes and show him some love. The less he can see, the more he can feel. So send his nerve endings into overdrive.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page46"
    }
  }), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKE YOUR MARK")]), _vm._v(" Running your nails down your partner’s body leaves some sexy evidence and adds a little kink. Start slowly—some people only enjoy a light scratch, others a bit more. An eye-catching manicure adds to the visuals.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quad-text-nested"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FEATHERED FRIENDS")]), _vm._v(" You can choose a big ostrich feather or a gaudy peacock plume—either way, feathers are a great way to tickle and tease. The sensation is subtle yet significant and, when paired with a blindfold, especially intriguing.")])])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 78
// module chunks = 0